export default "__VITE_ASSET__2d2a05c4__"